import { FILE_EXTENSIONS } from 'src/types/enum';

export const DEFAULT_FILE_SIZE_LIMITS_MB: Record<string, number> = {
  [FILE_EXTENSIONS.PDF]: 300,
  [FILE_EXTENSIONS.PPT]: 300,
  [FILE_EXTENSIONS.PPTX]: 300,
  [FILE_EXTENSIONS.DOC]: 300,
  [FILE_EXTENSIONS.DOCX]: 300,
  [FILE_EXTENSIONS.ODS]: 300,
  [FILE_EXTENSIONS.ODP]: 300,
  [FILE_EXTENSIONS.ODT]: 300,
  [FILE_EXTENSIONS.RTF]: 300,
  [FILE_EXTENSIONS.DOT]: 300,

  [FILE_EXTENSIONS.MP3]: 400,
  [FILE_EXTENSIONS.MPGA]: 400,
  [FILE_EXTENSIONS.MP4]: 400,
  [FILE_EXTENSIONS.MPEG]: 400,
  [FILE_EXTENSIONS.WAV]: 400,
  [FILE_EXTENSIONS.M4A]: 400,
  [FILE_EXTENSIONS.WEBM]: 400,
  [FILE_EXTENSIONS.WEBA]: 400,
  [FILE_EXTENSIONS.MOV]: 400,
  [FILE_EXTENSIONS.M4V]: 400,
  [FILE_EXTENSIONS.THREE_GP]: 400,
  [FILE_EXTENSIONS.AAC]: 400,
  [FILE_EXTENSIONS.CAF]: 400,
  [FILE_EXTENSIONS.AMR]: 400,

  [FILE_EXTENSIONS.XLS]: 50,
  [FILE_EXTENSIONS.XLSX]: 50,
  [FILE_EXTENSIONS.CSV]: 50,
  [FILE_EXTENSIONS.TXT]: 50,

  [FILE_EXTENSIONS.PNG]: 50,
  [FILE_EXTENSIONS.JPEG]: 50,
  [FILE_EXTENSIONS.JPG]: 50,
  [FILE_EXTENSIONS.GIF]: 50,
  [FILE_EXTENSIONS.SVG]: 50
};
